import type { Task } from "@myapp/contract";
import { Badge, StatusHeaderCard } from "../../../shared/ui";
import { WORKER_RESCHEDULING_COLOR, WORKER_RESCHEDULING_LABEL } from "../../../features/work-session";

type Props = {
  task: Task;
  statusLabel: string;
  statusColor: string;
  typeLabel: string;
  terminText: string;
  terminUnscheduled: boolean;
  deadlineText: string;
  deadlineOverdue: boolean;
};

/** Neutral tint for the Aufgabentyp badge — it isn't a status, so it doesn't borrow one. */
const TYPE_BADGE_COLOR = "#64748B";

/**
 * The task page's anchor card — status, Aufgabentyp and the Termin/Abgabefrist, the facts a
 * technician reads first. Composes the shared `StatusHeaderCard` the same way the appointment
 * page's header does; the differences are what goes in `badges`/`primaryLabel`/`secondary`.
 */
export const TaskStatusHeader = ({
  task,
  statusLabel,
  statusColor,
  typeLabel,
  terminText,
  terminUnscheduled,
  deadlineText,
  deadlineOverdue,
}: Props) => (
  <StatusHeaderCard
    statusLabel={statusLabel}
    statusColor={statusColor}
    badges={
      <>
        <Badge color={TYPE_BADGE_COLOR} label={typeLabel} size="sm" />
        {task.schedule?.needsRescheduling && (
          <Badge color={WORKER_RESCHEDULING_COLOR} label={WORKER_RESCHEDULING_LABEL} size="sm" />
        )}
      </>
    }
    primaryLabel="Termin"
    primaryValue={terminText}
    primaryValueClassName={terminUnscheduled ? "text-slate-400" : undefined}
    secondary={
      task.deadline ? (
        <p className="mt-2 text-sm">
          <span className="text-slate-500">Frist </span>
          <span className={deadlineOverdue ? "font-medium text-red-600" : "text-slate-700"}>
            {deadlineText}
            {deadlineOverdue && " · überfällig"}
          </span>
        </p>
      ) : undefined
    }
  />
);
